(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["album-image-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    var TARGET_FALLBACKS = [
      '[data-apg-target] img', '[data-apg-target]',
      '.product-media-container img', 'product-media-gallery img',
      '.product__media img', '.product-media img', '.product__media-item img'
    ];

    function targetImg(root){
      var sel = root.getAttribute('data-target');
      var list = (sel ? [sel] : []).concat(TARGET_FALLBACKS);
      for (var i = 0; i < list.length; i++){
        var el = null;
        try { el = document.querySelector(list[i]); } catch (e) {}
        if (el) return el;
      }
      return null;
    }

    // The /cart/add fetch override is installed by the early inline <script> at the
    // top of this block. Here we just publish the current pick's line item
    // properties to that shared global for the override to read.
    window.__apgCart = window.__apgCart || { selection: null };

    function init(root){
      if (root.hasAttribute('data-apg-init')) return;
      root.setAttribute('data-apg-init', '1');

      var API = (root.getAttribute('data-api') || '').replace(/\/+$/, '');
      var searchbox = root.querySelector('.apg__searchbox');
      var form = root.querySelector('[data-form]');
      var input = root.querySelector('[data-input]');
      var results = root.querySelector('[data-results]');
      var status = root.querySelector('[data-status]');
      var context = root.querySelector('[data-context]');

      var overlay = null, currentItem = null;
      var selectedUrl = null, watching = false, watchTimer = null;

      function setStatus(m){ status.hidden = !m; status.textContent = m || ''; }

      function previewUrl(item){
        return API + '/api/v1/preview?source=' + encodeURIComponent(item.source || 'spotify') +
               '&id=' + encodeURIComponent(item.id);
      }

      function setContext(item){
        if (!item){ context.hidden = true; context.textContent = ''; return; }
        context.hidden = false;
        context.innerHTML =
          '<span class="apg__ctx-title"></span> <span class="apg__ctx-hint"></span>';
        context.querySelector('.apg__ctx-title').textContent =
          (item.name || '') + (item.artist ? ' — ' + item.artist : '');
        context.querySelector('.apg__ctx-hint').textContent = 'set as your product image';
      }

      function productLoading(on){
        var img = targetImg(root);
        if (!img) return;
        var host = img.parentElement || img;
        if (on){
          if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
          if (!overlay){ overlay = document.createElement('div'); overlay.className = 'apg__overlay'; overlay.innerHTML = '<span class="apg__spin"></span>'; }
          host.appendChild(overlay);
        } else if (overlay && overlay.parentNode){
          overlay.parentNode.removeChild(overlay);
        }
      }

      // Re-apply the picked poster if the theme swaps the product media back (it does
      // this on variant change), so the selection sticks across size/variant changes.
      function reapplySelected(){
        if (!selectedUrl) return;
        var img = targetImg(root);
        if (img && img.getAttribute('src') !== selectedUrl){
          img.removeAttribute('srcset');
          img.setAttribute('src', selectedUrl);
        }
      }
      function ensureMediaWatch(){
        if (watching) return;
        var img = targetImg(root);
        if (!img) return;
        var container = img.closest('.shopify-section, .product, product-info, main') || img.parentElement;
        if (!container) return;
        watching = true;
        var mo = new MutationObserver(function(){
          if (!selectedUrl) return;
          clearTimeout(watchTimer);
          watchTimer = setTimeout(reapplySelected, 60);
        });
        mo.observe(container, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset'] });
        var pf = productForm();
        if (pf) pf.addEventListener('change', function(){ clearTimeout(watchTimer); watchTimer = setTimeout(reapplySelected, 150); });
      }

      function setProductImage(url){
        var img = targetImg(root);
        if (!img) return false;
        selectedUrl = url;
        ensureMediaWatch();
        img.removeAttribute('srcset');
        if (img.getAttribute('src') === url && img.complete) return true;
        // Show the spinner until the newly selected image finishes loading
        // (the watermarked image is generated server-side, so it takes a moment).
        productLoading(true);
        var done = function(){
          img.removeEventListener('load', done);
          img.removeEventListener('error', done);
          productLoading(false);
        };
        img.addEventListener('load', done);
        img.addEventListener('error', done);
        img.setAttribute('src', url);
        return true;
      }

      // Attach the selection to the ordered product via line item properties.
      // Names start with "_" so they're hidden from the customer in cart/checkout
      // but still recorded on the order (visible in the Shopify admin).
      function productForm(){
        var scope = root.closest('.shopify-section, product-form, .product') || document;
        return scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      }
      function setProp(pf, key, value){
        var el = pf.querySelector('input[data-apg-prop="' + key + '"]');
        if (!el){
          el = document.createElement('input');
          el.type = 'hidden';
          el.setAttribute('data-apg-prop', key);
          el.name = 'properties[' + key + ']';
          pf.appendChild(el);
        }
        el.value = value == null ? '' : value;
      }
      function writeLineItemProps(item){
        var pf = productForm();
        if (!pf || !item) return;
        setProp(pf, '_Album', item.name || '');
        setProp(pf, '_Artist', item.artist || '');
        setProp(pf, '_Year', item.year || '');
        setProp(pf, '_Source', item.source || '');    // spotify / itunes
        setProp(pf, '_Album ID', item.id || '');       // id used to regenerate the print
        setProp(pf, '_Preview URL', previewUrl(item));
      }

      function doSearch(q){
        if (!q) return;
        if (!API){ results.hidden = false; results.innerHTML = '<div class="apg__error">Search isn\'t configured yet.</div>'; return; }
        results.hidden = false; results.innerHTML = '<div class="apg__muted">Searching…</div>';
        setStatus('');
        fetch(API + '/api/v1/search?q=' + encodeURIComponent(q))
          .then(function(r){ if (!r.ok) throw new Error('search ' + r.status); return r.json(); })
          .then(function(data){ renderResults((data.results || []), (data.source || 'spotify')); })
          .catch(function(){ results.innerHTML = '<div class="apg__error">Search failed. Please try again.</div>'; });
      }

      function renderResults(list, fallbackSource){
        results.innerHTML = '';
        if (!list.length){ results.innerHTML = '<div class="apg__empty">No matches. Try another title.</div>'; return; }
        list.forEach(function(item){
          if (!item.source) item.source = fallbackSource;
          var el = document.createElement('button');
          el.type = 'button'; el.className = 'apg__result'; el.setAttribute('role', 'option');
          var poster = document.createElement('span');
          poster.className = 'apg__result-poster';
          if (item.image) poster.style.backgroundImage = 'url("' + item.image + '")';
          var body = document.createElement('span'); body.className = 'apg__result-body';
          var title = document.createElement('span'); title.className = 'apg__result-title'; title.textContent = item.name || 'Untitled';
          var sub = document.createElement('span'); sub.className = 'apg__result-sub';
          sub.textContent = [item.artist, item.year].filter(Boolean).join(' · ');
          body.appendChild(title); body.appendChild(sub);
          el.appendChild(poster); el.appendChild(body);
          el.addEventListener('click', function(){ selectItem(item); });
          results.appendChild(el);
        });
      }

      function selectItem(item){
        currentItem = item;
        results.hidden = true;
        setStatus('');
        setContext(item);
        // Swap the product image to this album's framed, watermarked preview.
        setProductImage(previewUrl(item));
        // Record the pick on the order.
        window.__apgCart.selection = {
          '_Album': item.name || '',
          '_Artist': item.artist || '',
          '_Year': item.year || '',
          '_Source': item.source || '',
          '_Album ID': item.id || '',
          '_Preview URL': previewUrl(item)
        };
        writeLineItemProps(item);
        // Scroll up so the customer sees the product image update.
        var img = targetImg(root) || root;
        if (img && img.scrollIntoView) img.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      form.addEventListener('submit', function(e){ e.preventDefault(); doSearch(input.value.trim()); });

      // Close the results dropdown when clicking outside the search box.
      document.addEventListener('click', function(e){
        if (searchbox && !searchbox.contains(e.target)) results.hidden = true;
      });
    }

    function initAll(){ document.querySelectorAll('[data-apg]').forEach(init); }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-image-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    var TARGET_FALLBACKS = [
      '[data-fpi-target] img', '[data-fpi-target]',
      '.product-media-container img', 'product-media-gallery img',
      '.product__media img', '.product-media img', '.product__media-item img'
    ];

    function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

    function targetImg(root){
      var sel = root.getAttribute('data-target');
      var list = (sel ? [sel] : []).concat(TARGET_FALLBACKS);
      for (var i = 0; i < list.length; i++){
        var el = null;
        try { el = document.querySelector(list[i]); } catch (e) {}
        if (el) return el;
      }
      return null;
    }

    // The /cart/add fetch override is installed by the early inline <script> at the
    // top of this block. Here we just publish the current pick's line item
    // properties to that shared global for the override to read.
    window.__fpiCart = window.__fpiCart || { selection: null };

    function init(root){
      if (root.hasAttribute('data-fpi-init')) return;
      root.setAttribute('data-fpi-init', '1');

      var API = (root.getAttribute('data-api') || '').replace(/\/+$/, '');
      var GENRE = (root.getAttribute('data-genre') || '').trim();  // '' = all, 'animation' = filter
      var searchbox = root.querySelector('.fpi__searchbox');
      var form = root.querySelector('[data-form]');
      var input = root.querySelector('[data-input]');
      var results = root.querySelector('[data-results]');
      var gallery = root.querySelector('[data-gallery]');
      var grid = root.querySelector('[data-grid]');
      var moreBtn = root.querySelector('[data-more]');
      var status = root.querySelector('[data-status]');
      var context = root.querySelector('[data-context]');

      var all = [], shown = 0, overlay = null, currentItem = null;
      var selectedId = null;
      var selectedUrl = null, watching = false, watchTimer = null;
      var STEP = 10;   // "Show more" reveals this many additional posters per click

      // Lazy-load poster backgrounds as tiles scroll into the gallery. This replaces
      // content-visibility (which stacked tiles on mobile), so the grid stays a plain,
      // reliable CSS grid on every device while still not fetching 300 images at once.
      var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (!e.isIntersecting) return;
          var t = e.target, u = t.getAttribute('data-bg');
          if (u){ t.style.backgroundImage = 'url("' + u + '")'; t.removeAttribute('data-bg'); }
          io.unobserve(t);
        });
      }, { root: grid, rootMargin: '400px 0px' }) : null;

      function setStatus(m){ status.hidden = !m; status.textContent = m || ''; }

      function typeLabel(t){ return t === 'tv' ? 'TV series' : t === 'person' ? 'Person' : 'Movie'; }
      function setContext(item, count){
        if (!item){ context.hidden = true; context.textContent = ''; return; }
        context.hidden = false;
        context.innerHTML =
          '<div class="fpi__ctx-main"><span class="fpi__ctx-title"></span><span class="fpi__ctx-count"></span></div>' +
          '<div class="fpi__ctx-hint">Tap a poster to set it as your product image</div>';
        context.querySelector('.fpi__ctx-title').textContent = item.title || '';
        context.querySelector('.fpi__ctx-count').textContent =
          (count == null) ? 'Loading…' : (count + (count === 1 ? ' poster' : ' posters'));
      }
      function showSkeletons(){
        grid.innerHTML = '';
        var n = Math.max(colsPerRow(), 4);
        for (var i = 0; i < n; i++){ var s = document.createElement('div'); s.className = 'fpi__thumb fpi__skel'; grid.appendChild(s); }
        moreBtn.hidden = true;
      }

      function productLoading(on){
        var img = targetImg(root);
        if (!img) return;
        var host = img.parentElement || img;
        if (on){
          if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
          if (!overlay){ overlay = document.createElement('div'); overlay.className = 'fpi__overlay'; overlay.innerHTML = '<span class="fpi__spin"></span>'; }
          host.appendChild(overlay);
        } else if (overlay && overlay.parentNode){
          overlay.parentNode.removeChild(overlay);
        }
      }

      // Re-apply the picked poster if the theme swaps the product media back (it does
      // this on variant change), so the selection sticks across size/variant changes.
      function reapplySelected(){
        if (!selectedUrl) return;
        var img = targetImg(root);
        if (img && img.getAttribute('src') !== selectedUrl){
          img.removeAttribute('srcset');
          img.setAttribute('src', selectedUrl);
        }
      }
      function ensureMediaWatch(){
        if (watching) return;
        var img = targetImg(root);
        if (!img) return;
        var container = img.closest('.shopify-section, .product, product-info, main') || img.parentElement;
        if (!container) return;
        watching = true;
        var mo = new MutationObserver(function(){
          if (!selectedUrl) return;
          clearTimeout(watchTimer);
          watchTimer = setTimeout(reapplySelected, 60);
        });
        mo.observe(container, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset'] });
        var form = productForm();
        if (form) form.addEventListener('change', function(){ clearTimeout(watchTimer); watchTimer = setTimeout(reapplySelected, 150); });
      }

      function setProductImage(url){
        var img = targetImg(root);
        if (!img) return false;
        selectedUrl = url;
        ensureMediaWatch();
        img.removeAttribute('srcset');
        // Already showing this exact image -> nothing to load.
        if (img.getAttribute('src') === url && img.complete) return true;
        // Show the spinner until the newly selected image finishes loading
        // (the watermarked image is generated server-side, so it takes a moment).
        productLoading(true);
        var done = function(){
          img.removeEventListener('load', done);
          img.removeEventListener('error', done);
          productLoading(false);
        };
        img.addEventListener('load', done);
        img.addEventListener('error', done);
        img.setAttribute('src', url);
        return true;
      }

      // Attach the selection to the ordered product via line item properties.
      // Names start with "_" so they're hidden from the customer in cart/checkout
      // but still recorded on the order (visible in the Shopify admin).
      function productForm(){
        var scope = root.closest('.shopify-section, product-form, .product') || document;
        return scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      }
      function setProp(form, key, value){
        var input = form.querySelector('input[data-fpi-prop="' + key + '"]');
        if (!input){
          input = document.createElement('input');
          input.type = 'hidden';
          input.setAttribute('data-fpi-prop', key);
          input.name = 'properties[' + key + ']';
          form.appendChild(input);
        }
        input.value = value == null ? '' : value;
      }
      function writeLineItemProps(im){
        var form = productForm();
        if (!form || !currentItem) return;
        setProp(form, '_Title', currentItem.title || '');
        setProp(form, '_Type', currentItem.media_type || '');   // movie / tv / person
        setProp(form, '_Media ID', currentItem.id || '');       // TMDB id of the movie/series
        setProp(form, '_Image ID', im.id || '');                // TMDB id of the chosen image
        setProp(form, '_Image URL', im.url || im.thumb || '');  // clickable watermarked image
      }

      function doSearch(q){
        if (!q) return;
        if (!API){ results.hidden = false; results.innerHTML = '<div class="fpi__error">Search isn\'t configured yet.</div>'; return; }
        results.hidden = false; results.innerHTML = '<div class="fpi__muted">Searching…</div>';
        gallery.hidden = true; setStatus('');
        // On the animation product GENRE is 'animation', so the API only returns
        // titles in that genre; on the movies/series product it's '' (all results).
        var qs = '/api/search?query=' + encodeURIComponent(q) + (GENRE ? '&genre=' + encodeURIComponent(GENRE) : '');
        fetch(API + qs)
          .then(function(r){ if (!r.ok) throw new Error('search ' + r.status); return r.json(); })
          .then(function(data){ renderResults(data.results || []); })
          .catch(function(){ results.innerHTML = '<div class="fpi__error">Search failed. Please try again.</div>'; });
      }

      function renderResults(list){
        results.innerHTML = '';
        if (!list.length){ results.innerHTML = '<div class="fpi__empty">No matches. Try another title.</div>'; return; }
        list.forEach(function(item){
          var el = document.createElement('button');
          el.type = 'button'; el.className = 'fpi__result'; el.setAttribute('role', 'option');
          var poster = document.createElement('span');
          poster.className = 'fpi__result-poster';
          if (item.image) poster.style.backgroundImage = 'url("' + item.image + '")';
          var body = document.createElement('span'); body.className = 'fpi__result-body';
          var title = document.createElement('span'); title.className = 'fpi__result-title'; title.textContent = item.title || 'Untitled';
          var type = document.createElement('span'); type.className = 'fpi__result-type'; type.textContent = typeLabel(item.media_type);
          body.appendChild(title); body.appendChild(type);
          el.appendChild(poster); el.appendChild(body);
          el.addEventListener('click', function(){ selectItem(item); });
          results.appendChild(el);
        });
      }

      function selectItem(item){
        currentItem = item;
        results.hidden = true;
        gallery.hidden = false;
        shown = 0; all = []; selectedId = null; selectedUrl = null; window.__fpiCart.selection = null; setStatus('');
        setContext(item, null);
        showSkeletons();
        productLoading(true);
        fetch(API + '/api/images?type=' + encodeURIComponent(item.media_type) + '&id=' + encodeURIComponent(item.id))
          .then(function(r){ if (!r.ok) throw new Error('images ' + r.status); return r.json(); })
          .then(function(data){
            productLoading(false);
            all = data.images || [];
            if (!all.length){ grid.innerHTML = ''; setContext(item, 0); setStatus('No posters found for this title.'); return; }
            setContext(item, all.length);
            renderGrid();
          })
          .catch(function(){ productLoading(false); grid.innerHTML = ''; setStatus("Couldn't load posters. Please try again."); });
      }

      // Columns the grid currently shows, from the resolved auto-fill tracks — so the
      // collapsed view fills exactly one row for the screen size (responsive), not a
      // fixed 3.
      function colsPerRow(){
        try{
          var t = getComputedStyle(grid).gridTemplateColumns;
          var n = t.split(/\s+/).filter(function(s){ return s && s !== 'none'; }).length;
          return n > 0 ? n : 3;
        }catch(e){ return 3; }
      }

      function renderGrid(){
        if (io) io.disconnect();
        grid.innerHTML = '';
        var perRow = colsPerRow();
        // Start collapsed at exactly one row; "Show more" grows this window by STEP.
        if (shown <= 0) shown = perRow;
        if (shown > all.length) shown = all.length;
        var list = all.slice(0, shown);
        list.forEach(function(im){
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'fpi__thumb' + (im.id === selectedId ? ' is-selected' : '');
          var url = im.thumb || im.url;
          if (io){ b.setAttribute('data-bg', url); io.observe(b); }
          else b.style.backgroundImage = 'url("' + url + '")';
          b.setAttribute('aria-label', 'Poster' + (im.language ? ' (' + im.language + ')' : ''));
          b.setAttribute('aria-pressed', im.id === selectedId ? 'true' : 'false');
          var check = document.createElement('span');
          check.className = 'fpi__check'; check.setAttribute('aria-hidden', 'true'); check.textContent = '✓';
          b.appendChild(check);
          b.addEventListener('click', function(){ pick(im); });
          grid.appendChild(b);
        });
        var remaining = all.length - shown;
        if (remaining > 0){
          // Reveal the next chunk — the count is the min of STEP and what's left.
          moreBtn.hidden = false;
          moreBtn.textContent = 'Show more (' + Math.min(STEP, remaining) + ')';
        } else if (all.length > perRow){
          // Everything is shown -> offer to collapse back to a single row.
          moreBtn.hidden = false;
          moreBtn.textContent = 'Show fewer';
        } else {
          moreBtn.hidden = true;
        }
      }

      function pick(im){
        // Product image = the poster inside a frame sized to its aspect (no crop/stretch).
        var framed = im.url
          ? (im.url + '&frame=1' + (im.width && im.height ? ('&w=' + im.width + '&h=' + im.height) : ''))
          : (im.thumb || '');
        setProductImage(framed);
        window.__fpiCart.selection = {
          '_Title': (currentItem && currentItem.title) || '',
          '_Type': (currentItem && currentItem.media_type) || '',
          '_Media ID': (currentItem && currentItem.id) || '',
          '_Image ID': im.id || '',
          '_Image URL': im.url || im.thumb || ''
        };
        writeLineItemProps(im);
        selectedId = im.id;
        // Keep the current window (the picked tile is already visible) and just
        // re-render to move the selected highlight.
        renderGrid();
        // Scroll up so the customer sees the product image update.
        var img = targetImg(root) || root;
        if (img && img.scrollIntoView) img.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      form.addEventListener('submit', function(e){ e.preventDefault(); doSearch(input.value.trim()); });
      moreBtn.addEventListener('click', function(){
        if (shown < all.length) shown = Math.min(all.length, shown + STEP);  // Show more (N)
        else shown = colsPerRow();                                            // Show fewer -> one row
        renderGrid();
      });

      // Close the results dropdown when clicking outside the search box.
      document.addEventListener('click', function(e){
        if (searchbox && !searchbox.contains(e.target)) results.hidden = true;
      });
    }

    function initAll(){ document.querySelectorAll('[data-fpi]').forEach(init); }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
